import { render } from "./ChapterPage.vue?vue&type=template&id=4cc61851"
import script from "./ChapterPage.vue?vue&type=script&lang=js"
export * from "./ChapterPage.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__